import {
  primaryColor,
  primaryDarkColor,
  borderSubtleColor,
  textPrimaryColor,
  textMutedColor,
  boxShadow,
} from 'assets/jss/material-dashboard-react';

const LoginStyle = () => ({
  cardTitleRed: {
    color: '#D64545',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '500',
    marginBottom: '3px',
    textDecoration: 'none',
    textAlign: 'center',
  },
  authShell: {
    width: '100%',
    maxWidth: 420,
    margin: '0 auto',
  },
  brandRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 28,
    textAlign: 'center',
  },
  brandTagline: {
    margin: '14px 0 0',
    fontSize: 13,
    color: textMutedColor,
    lineHeight: 1.5,
  },
  loginBox: {
    border: `1px solid ${borderSubtleColor}`,
    borderRadius: 16,
    background: '#ffffff',
    ...boxShadow,
    overflow: 'hidden',
    padding: '24px 28px 28px',
  },
  formTitle: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 20,
    margin: '0 0 6px',
    color: textPrimaryColor,
  },
  formSubtitle: {
    textAlign: 'center',
    fontSize: 13,
    color: textMutedColor,
    margin: '0 0 8px',
    lineHeight: 1.5,
  },
  fields: {
    padding: '4px 0 8px',
  },
  timerText: {
    textAlign: 'center',
    fontSize: 13,
    color: textMutedColor,
    margin: '4px 0 16px',
    lineHeight: 1.5,
  },
  progressWrap: {
    height: 3,
    backgroundColor: borderSubtleColor,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    backgroundColor: primaryColor,
    transition: 'width 1s linear',
    borderRadius: '0 2px 2px 0',
  },
  submitRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
    padding: '4px 20px 0',
  },
  submitBtn: {
    minWidth: 140,
    height: 44,
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 500,
    textTransform: 'none',
    margin: '0 !important',
    boxShadow: '0 6px 16px rgba(0, 168, 188, 0.28)',
    '&:hover': {
      backgroundColor: primaryDarkColor,
    },
  },
  secondaryBtn: {
    minWidth: 140,
    height: 44,
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 500,
    textTransform: 'none',
    margin: '0 !important',
  },
  forgetPassword: {
    display: 'flex',
    margin: '12px 16px 4px',
    justifyContent: 'center',
  },
  forgetBtn: {
    backgroundColor: 'transparent',
    border: 'none',
    color: primaryColor,
    cursor: 'pointer',
    fontSize: 13,
    padding: '8px 12px',
    borderRadius: 8,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(0, 168, 188, 0.08)',
    },
  },
  snackbar: {
    direction: 'rtl',
  },
  snackbarContent: {
    backgroundColor: '#1F2A32',
    borderRadius: 10,
    fontFamily: 'FrutigerRegular, Tahoma, Arial, sans-serif',
    fontSize: 14,
    minWidth: 280,
    boxShadow: '0 8px 24px rgba(31, 42, 50, 0.18)',
  },
  close: {
    padding: 6,
  },
  card: {
    marginBottom: 16,
    borderRadius: 12,
  },
  cardFooter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    padding: '8px 12px 4px',
    border: 'none',
  },
});

export default LoginStyle;
